var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpMethod } from './drivers/default/enums/httpMethod';
import { Orion } from './orion';
export class HttpClient {
    constructor(baseUrl, client) {
        this.baseUrl = baseUrl;
        this.client = client;
    }
    request(url, method, params = {}, data = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = Object.assign(Orion.getHttpClientConfig(), {
                baseURL: this.baseUrl,
                url,
                method,
                params,
            });
            if (method !== HttpMethod.GET) {
                config.data = data;
            }
            return this.client.request(config);
        });
    }
    getAxios() {
        return this.client;
    }
}
//# sourceMappingURL=httpClient.js.map